var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('f7-page',[_c('navbar',{attrs:{"text":_vm.$t('ExtremeWeatherCondicions_title')}}),_vm._v(" "),_c('DxExtremeWeatherCondicionsDatabase')],1)}
var staticRenderFns = []

export { render, staticRenderFns }